module.exports = __webpack_public_path__ + "img/room-bg.8b8a7d0c.png";